import type { View } from "@-/com.npmjs.react-native";
import type { AnimatedRef } from "@-/com.npmjs.react-native-reanimated";
import { createContext } from "react";

/**
 * Registers a view inside which touches must never start the deck's horizontal card pan; returns
 * the unregister. Absent outside a Learn deck.
 */
export type RegisterLearnFlashcardHorizontalGestureBlocker = (
  view: AnimatedRef<View>,
) => () => void;

export const LearnFlashcardHorizontalGestureBlockersContext =
  createContext<RegisterLearnFlashcardHorizontalGestureBlocker | null>(null);
